import { Component, Input } from '@angular/core';
import { DailyRebootInfo } from './dailyReboot.data';

@Component({
    selector: 'na-dailyReboot-preview',
    templateUrl: './dailyReboot-preview.component.html',
    standalone: false
})
export class DailyRebootPreviewComponent {
    _info: DailyRebootInfo;
    @Input('config')
    set config(c: any) {
        this._info = c instanceof DailyRebootInfo ? c : new DailyRebootInfo(c);;
    }

    @Input('supportStagger') _supportStagger: boolean = false;
}